import "./TheBlueprint.module.css";
import Header from "@/reusable_sections/Header";
import Blueprint from "./sections/Blueprint";
import TechStack from "./sections/TechStack";
import StartYourBlueprint from "./sections/StartYourBlueprint";
import Footer from "@/reusable_sections/Footer";
export default function TheBlueprintPage() {
  return <div>
      <Header />
      <Blueprint />
      <TechStack />
      <StartYourBlueprint />
      <Footer />
    </div>;
}